<template>
  <AnswerMain/>
</template>

<script>
import AnswerMain from '@/components/AnswerMain'

export default {
  components: {
    AnswerMain
  }
}
</script>
